import { Marker } from "mapbox-gl";
import { FavouriteLockerType, FavouriteLocker, LocalStorageFavouriteLocker, PointLocation } from "../data/LockerDataTypes"
import { ROUTE, STORAGE_BASE_URL } from "../Settings";

export const getFavouriteLockerDefaultMapCenter = (favouriteLockers: LocalStorageFavouriteLocker[]): PointLocation | null => {
    let orderedFavouriteLockerTypes = getOrderedFavouriteLockerTypes();
    
    for(let x of orderedFavouriteLockerTypes){
        let favouriteLocker = favouriteLockers.find(y => y.type === x.type);
        if(favouriteLocker){
            return {
                lng: favouriteLocker.lng,
                lat: favouriteLocker.lat
            } as PointLocation
        }
    }
    
    return null;
}

export const getOrderedFavouriteLockerTypes = () : FavouriteLocker[] => {
    const imageUrl = `${STORAGE_BASE_URL}${ROUTE}`;
    const favouriteEasyboxPin = `<img src=${imageUrl}/PinEasyboxFav.png>`
    const favouriteHomeEasyboxPin = `<img src=${imageUrl}/PinEasyboxHomeFav.png>`
    const favouriteWorkEasyboxPin = `<img src=${imageUrl}/PinEasyboxWorkFav.png>`

    return [
        {icon: favouriteEasyboxPin, mapCenterOrder: 0,  type: FavouriteLockerType.Unknown} as FavouriteLocker,
        {icon: favouriteHomeEasyboxPin, mapCenterOrder: 1,  type: FavouriteLockerType.Home} as FavouriteLocker,
        {icon: favouriteWorkEasyboxPin, mapCenterOrder: 2,  type: FavouriteLockerType.Work} as FavouriteLocker
    ].sort((a, b) => { return a.mapCenterOrder - b.mapCenterOrder;});
}

export const setMarkersElementAsFavourite = (marker: Marker, icon: string): void => {
    if(!marker){
        return;
    }
    const el = marker.getElement();
    el.classList.add('favourite');
    el.innerHTML = icon;
}

